import { useToast } from "@chakra-ui/react";
import axios from "axios";

// Mensagem de erro pro operador a partir de um erro de chamada HTTP: usa o
// `message` do corpo da resposta quando o backend manda um, senão o fallback.
export const getApiErrorMessage = (error: unknown, fallback = "Erro inesperado."): string => {
  if (axios.isAxiosError(error)) {
    const message = (error.response?.data as { message?: unknown } | undefined)?.message;
    if (typeof message === "string" && message) return message;
  }
  return fallback;
};

// Fábrica de `onError` pra mutations: `toastErro("Título")`
// devolve um handler que mostra o `message` do backend (ou o fallback) num
// toast de erro. Tipado em `unknown` pra não precisar de `any` nos callers.
export function useApiErrorToast() {
  const toast = useToast();

  return (titulo: string, fallback?: string) => (error: unknown) =>
    toast({
      title: titulo,
      description: getApiErrorMessage(error, fallback),
      status: "error",
      duration: 5000,
      isClosable: true,
    });
}
